import { Injectable, ErrorHandler, Injector } from "@angular/core";
import { InsightsService } from "../services/insights.service";

@Injectable()
export class T4ErrorHandler extends ErrorHandler {
    constructor(private monitoringService: InsightsService) {
        super();
    }

    handleError(error: any): void {
        //const monitoringService = this.injector.get(InsightsService);
        this.monitoringService.logError(error);
        super.handleError(error);
    }
}